import announcementRouteBuilder from "@cloudspire/shared/constants/routes/api/announcement";
import authRouteBuilder from "@cloudspire/shared/constants/routes/api/auth";
import bookingRouteBuilder from "@cloudspire/shared/constants/routes/api/booking";
import bookingDownloadRouteBuilder from "@cloudspire/shared/constants/routes/api/booking/download";
import bookingGuestRouteBuilder from "@cloudspire/shared/constants/routes/api/booking/guest";
import bookingMessageRouteBuilder from "@cloudspire/shared/constants/routes/api/booking/message";
import channelRouteBuilder from "@cloudspire/shared/constants/routes/api/channel";
import channelPartnershipRouteBuilder from "@cloudspire/shared/constants/routes/api/channel/partnership";
import countryRouteBuilder from "@cloudspire/shared/constants/routes/api/country";
import fileRouteBuilder from "@cloudspire/shared/constants/routes/api/file";
import hotelReviewRouteBuilder from "@cloudspire/shared/constants/routes/api/hotel/review";
import invoiceRouteBuilder from "@cloudspire/shared/constants/routes/api/invoice";
import legacyBookingRouteBuilder from "@cloudspire/shared/constants/routes/api/legacy/booking";
import legacyPaymentRouteBuilder from "@cloudspire/shared/constants/routes/api/legacy/payment";
import legacyToolRouteBuilder from "@cloudspire/shared/constants/routes/api/legacy/tool";
import legacyChannelRouteBuilder from "@cloudspire/shared/constants/routes/api/legacy/channel";
import legacyUserRouteBuilder from "@cloudspire/shared/constants/routes/api/legacy/user";
import postRouteBuilder from "@cloudspire/shared/constants/routes/api/post";
import customerRouteBuilder from "@cloudspire/shared/constants/routes/api/user/customer";
import userCustomerMessageRouteBuilder from "@cloudspire/shared/constants/routes/api/user/customer/message";
import userCustomerMessageAttachmentRouteBuilder from "@cloudspire/shared/constants/routes/api/user/customer/message/attachment";
import passwordResetRouteBuilder from "@cloudspire/shared/constants/routes/api/user/passwordReset";
import twoFactorAuthRouteBuilder from "@cloudspire/shared/constants/routes/api/users/twoFactorAuthentification/challenge";
import Router from "@cloudspire/shared/utils/router/Router";
import Uri from "@cloudspire/shared/utils/uri/Uri";
import paymentRouteBuilder from "@cloudspire/shared/constants/routes/api/payment";
import hotelDocumentationRouteBuilder from "@cloudspire/shared/constants/routes/api/hotel/documentation";
import hotelDocumentationCategoryRouteBuilder from "@cloudspire/shared/constants/routes/api/hotel/documentation/category";
import channelInsuranceRouteBuilder from "@cloudspire/shared/constants/routes/api/channel/insurance";
import paymentAncvConnectTransactionRouteBuilder from "@cloudspire/shared/constants/routes/api/payment/ancvConnect/transaction";
import authSsoRouteBuilder from "@cloudspire/shared/constants/routes/api/auth/sso";
import metricRouteBuilder from "@cloudspire/shared/constants/routes/api/metric";
import hotelAppointmentRouteBuilder from "@cloudspire/shared/constants/routes/api/hotel/appointment";
import hotelRouteBuilder from "@cloudspire/shared/constants/routes/api/hotel";
import hotelRoomRouteBuilder from "@cloudspire/shared/constants/routes/api/hotel/room";
import hotelServiceRouteBuilder from "@cloudspire/shared/constants/routes/api/hotel/service";

/**
 * Génère les routes de l’API
 * @param {object} [options]
 * @param {import("@cloudspire/shared/utils/uri/Uri").default} [options.baseUrl]
 * @param {boolean} [options.useProxy]
 */
export default function generateApiRouter(options = {}) {
  const { baseUrl = new Uri(), useProxy = false } = options;

  const apiRouter = new Router();

  const localBaseUrl = baseUrl.clone();

  // Si l’API doit être utilisée via un proxy, on ajoute le chemin `/api/proxy` à l’URL de base
  if (useProxy) {
    localBaseUrl.setPath(`${localBaseUrl.getPath()}/api/proxy`);
  }

  // legacy route builders
  legacyBookingRouteBuilder(apiRouter);
  legacyPaymentRouteBuilder(apiRouter);
  legacyToolRouteBuilder(apiRouter);

  // route builders
  announcementRouteBuilder(apiRouter);
  authRouteBuilder(apiRouter);
  authSsoRouteBuilder(apiRouter);
  bookingDownloadRouteBuilder(apiRouter);
  bookingGuestRouteBuilder(apiRouter);
  bookingMessageRouteBuilder(apiRouter);
  bookingRouteBuilder(apiRouter);
  channelInsuranceRouteBuilder(apiRouter);
  channelPartnershipRouteBuilder(apiRouter);
  channelRouteBuilder(apiRouter);
  countryRouteBuilder(apiRouter);
  customerRouteBuilder(apiRouter);
  fileRouteBuilder(apiRouter);
  hotelAppointmentRouteBuilder(apiRouter);
  hotelDocumentationCategoryRouteBuilder(apiRouter);
  hotelDocumentationRouteBuilder(apiRouter);
  hotelReviewRouteBuilder(apiRouter);
  hotelRoomRouteBuilder(apiRouter);
  hotelRouteBuilder(apiRouter);
  hotelServiceRouteBuilder(apiRouter);
  invoiceRouteBuilder(apiRouter);
  legacyChannelRouteBuilder(apiRouter);
  legacyUserRouteBuilder(apiRouter);
  metricRouteBuilder(apiRouter);
  passwordResetRouteBuilder(apiRouter);
  paymentAncvConnectTransactionRouteBuilder(apiRouter);
  paymentRouteBuilder(apiRouter);
  postRouteBuilder(apiRouter);
  twoFactorAuthRouteBuilder(apiRouter);
  userCustomerMessageAttachmentRouteBuilder(apiRouter);
  userCustomerMessageRouteBuilder(apiRouter);

  if (localBaseUrl) {
    apiRouter.setBaseUrl(localBaseUrl);
  }

  return apiRouter;
}
